import { Eye, Zap, TrendingUp } from "lucide-react";
import { SectionHead } from "@/components/SectionHead";
import { Reveal } from "@/components/Reveal";

const POINTS = [
  { icon: Eye, title: "See clearly", copy: "Understand what is happening across your properties." },
  { icon: Zap, title: "Act earlier", copy: "Identify maintenance, financial and operational issues before they become larger problems." },
  { icon: TrendingUp, title: "Grow smarter", copy: "Use property intelligence to improve performance and protect long-term asset value." },
];

export const ProblemSection = () => (
  <section className="section bg-white" data-testid="problem-section">
    <div className="container-x">
      <SectionHead
        eyebrow="The Problem"
        title={<>Your properties generate data every day.<span className="block text-navy">ANFORD turns it into direction.</span></>}
        copy="Property information is often scattered across spreadsheets, messages, invoices, managers, vendors and disconnected systems. ANFORD brings your property operations together and helps turn that information into decisions."
      />
      <div className="mt-12 grid gap-4 md:mt-16 md:grid-cols-3 md:gap-6">
        {POINTS.map((p, i) => (
          <Reveal key={p.title} delay={i * 0.1}>
            <article data-testid={`problem-point-${i + 1}`} className="h-full rounded-2xl border border-navy/10 bg-white p-7 md:p-8">
              <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-navy text-gold-soft">
                <p.icon className="h-5 w-5" />
              </span>
              <h3 className="mt-6 font-display text-lg font-bold uppercase tracking-wide text-navy-ink">{p.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-slate2">{p.copy}</p>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
